import clsx from "clsx";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Tooltip } from "../tooltip";
import Typography from "../typography/Typography";

type Props = {
  className?: string;
  showNumber: number;
  items: Array<unknown>;
  renderItem: (item: unknown, index: number) => ReactNode;
  moreDisplayMode?: "tooltip" | "link";
  moreLink?: string;
};

const MoreItems = ({
  items,
  renderItem,
  moreDisplayMode = "tooltip",
  moreLink
}: Omit<Props, "showNumber" | "className">) => {
  if (!items.length) return null;

  if (moreDisplayMode === "link" && moreLink) {
    return (
      <Link to={moreLink}>
        <Typography
          tag="span"
          variant="body4"
          className="ml-1 white-space-no-wrap"
        >
          (+{items.length} More)
        </Typography>
      </Link>
    );
  }

  return (
    <Tooltip
      variant="interactive"
      content={
        <div style={{ maxHeight: "500px", overflowX: "auto" }}>
          {items.map((item, index) => (
            <div className="word-break-break-all" key={index}>
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      }
    >
      <Typography
        tag="span"
        variant="body4"
        className="ml-1 cursor-default white-space-no-wrap"
      >
        (+{items.length} More)
      </Typography>
    </Tooltip>
  );
};

const MoreItemsList = ({
  className,
  showNumber,
  items,
  renderItem,
  moreDisplayMode,
  moreLink
}: Props) => {
  const firstTwo = items.slice(0, showNumber);
  const rest = items.slice(showNumber);

  return (
    <div className={clsx(className)}>
      {firstTwo.map((item, index) => renderItem(item, index))}
      <MoreItems
        items={rest}
        renderItem={renderItem}
        moreDisplayMode={moreDisplayMode}
        moreLink={moreLink}
      />
    </div>
  );
};

export default MoreItemsList;
